import { NavLink as Link, Outlet } from "react-router-dom";
import { Fragment } from "react";
import { IoIosSearch } from "react-icons/io";
import { BiChat } from "react-icons/bi";
import { IoSettingsOutline } from "react-icons/io5";
import { LuMessageSquare } from "react-icons/lu";
import { MdGridView } from "react-icons/md";
import { MdOutlineContactPhone } from "react-icons/md";
import { GiOpenChest } from "react-icons/gi";
import SupportNavBar from "./SupportNavBar";
import "./Support.css";

const SupportDash = () => {
  const NavLink = ({ isActive }) => ({
    background: isActive ? "#284697" : "",
    color: isActive ? "white" : "",
  });

  return (
    <Fragment>
      <SupportNavBar />
      <div className="support-nav">
        <div className="support-logo">
          <img
            src="https://res.cloudinary.com/dmk6amr96/image/upload/v1740848255/Frame_1_qz7nmp.png"
            alt=""
          />
        </div>
        <div className="support-mobile-link">
          <Link to="/" style={NavLink}>
            <MdGridView style={{ fontSize: "24px" }} className="icon" />
            Overview
          </Link>
          <Link to="/SupportMessage" style={NavLink}>
            <LuMessageSquare style={{ fontSize: "24px" }} className="icon" />
            Public Message
          </Link>
          <Link to="/AdminChat" style={NavLink}>
            <BiChat style={{ fontSize: "24px" }} className="icon" />
            Admin Message
          </Link>
          <Link to="/TrackPackage" style={NavLink}>
            <IoIosSearch style={{ fontSize: "24px" }} className="icon" />
            Track Package
          </Link>
          <Link to="/allcustomerconcern" style={NavLink}>
            <MdOutlineContactPhone
              style={{ fontSize: "24px" }}
              className="icon"
            />
            Raised Concern
          </Link>
          <Link to="/openconcerns" style={NavLink}>
            <GiOpenChest style={{ fontSize: "24px" }} className="icon" />
            Open Concern
          </Link>
          <Link to="/SupportSetting" style={NavLink}>
            <IoSettingsOutline style={{ fontSize: "24px" }} className="icon" />
            Setting
          </Link>
        </div>
      </div>
      <Outlet />
    </Fragment>
  );
};

export default SupportDash;
